import { useKeycloak } from '@react-keycloak/web';

export default function useAccess() {
    const { keycloak } = useKeycloak();
    const realms = keycloak.realmAccess?.roles;
    const companyKeys = realms
        .filter(role => role.startsWith('ACCESS_'))
        .map(role => role.replace('ACCESS_', ''))
        .sort();
    const apmGroups = realms
        .filter(role => role.startsWith('APMGROUP_'))
        .map(role => role.replace('APMGROUP_', ''))
        .map(role => {
            const companyKey = companyKeys.find(key => role.startsWith(`${key}_`));
            if (companyKey) {
                const apmGroupKey = role.replace(`${companyKey}_`, '');
                return {
                    apmGroupKey,
                    companyKey,
                };
            }
            return null;
        })
        .filter(truthy => truthy);
    const userCompanies = companyKeys.map(companyKey => ({
        apmGroupKeys: apmGroups
            .filter(apmGroup => apmGroup.companyKey === companyKey)
            .map(apmGroup => apmGroup.apmGroupKey)
            .sort(),
        key: companyKey,
    }));
    return {
        isCleveron: companyKeys.includes('CLEVERON'),
        userCompanies,
        username: keycloak.profile?.username,
    };
}
